export enum QRCodeType {
  DIGITAL_MENU = "DIGITAL_MENU",
  DELIVERY_N_PICKUP = "DELIVERY_N_PICKUP",
}

export enum QRCodeSettingsEnum {
  INCLUDE_BRAND_LOGO = "INCLUDE_BRAND_LOGO",
  USE_BRAND_COLORS = "USE_BRAND_COLORS",
}
